exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info-container[data-v-7ac93152] {\n  margin: 30px 0;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 1fr 1fr;\n      grid-template-columns: 1fr 1fr 1fr;\n  gap: 30px;\n}\n.rating-grid[data-v-7ac93152] {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 60% 40%;\n      grid-template-columns: 60% 40%;\n  gap: 30px;\n}\n@media (max-width: 480px) {\n.rating-grid[data-v-7ac93152]{\n    -ms-grid-columns: 100%;\n        grid-template-columns: 100%;\n}\n.info-container[data-v-7ac93152] {\n    -ms-grid-columns: 100%;\n        grid-template-columns: 100%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7ac93152","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/rating/UserRating.vue
// module id = 948
// module chunks = 1